export default function createPushClient(wsUrl) {
  let ws = null;
  let channels = {};  // { canal: { handlers } }

  function connect() {
    ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      console.log("[PUSH] Connected:", wsUrl);

      // Envia inscrição para TODOS os canais registrados
      Object.keys(channels).forEach(channelName => {
        console.log("[PUSH] SUBSCRIBE ->", channelName);

        ws.send(JSON.stringify({
          action: "subscribe",
          channel: channelName
        }));
      });
    };

    ws.onmessage = (msg) => {
      try {
        const data = JSON.parse(msg.data);
        if (!data.event || !data.message || !data.channel) return;

        const chan = data.channel;
        const evt = data.event;

        if (channels[chan] && channels[chan].handlers[evt]) {
          const payload = JSON.parse(data.message);
          channels[chan].handlers[evt](payload);
        }

      } catch (e) {
        console.error("[PUSH] Invalid WS message", e);
      }
    };

    ws.onclose = () => {
      console.warn("[PUSH] Disconnected. Reconnecting in 2s...");
      setTimeout(connect, 2000);
    };

    ws.onerror = (err) => console.error("[PUSH] Error:", err);
  }

  connect();

  return {
    subscribe(channelName) {
      // cria se não existir
      if (!channels[channelName]) {
        channels[channelName] = {
          handlers: {}
        };
      }

      // se já estiver conectado, inscreve imediatamente
      if (ws.readyState === WebSocket.OPEN) {
        console.log("[PUSH] SUBSCRIBE imediato ->", channelName);

        ws.send(JSON.stringify({
          action: "subscribe",
          channel: channelName
        }));
      }

      return {
        bind(eventName, callback) {
          channels[channelName].handlers[eventName] = callback;
        }
      };
    }
  };
}